module.exports = __webpack_public_path__ + "static/media/Panama-Drinks.52552095.jpg";